<template>
  <div class="search">
    <el-form class="searchform" :class="{'search-hidden':search_hidden}" :style="{'height':search_height}" ref="form" :model="form" label-width="80px" label-position="left">
      <div class="mm-row">
        <div class="mm-col">
          <div class="mm-item">
            <label class="mm-label">賬號</label>
            <el-input v-model="form.account_num" clearable></el-input>
          </div>
        </div>
        <div class="mm-col">
          <div class="mm-item">
            <label class="mm-label">持卡人名稱</label>
            <el-input v-model="form.account_name" clearable></el-input>
          </div>
        </div>
      </div>
      <div class="mm-row">
        <div class="mm-col">
          <div class="mm-item">
            <label class="mm-label">賬號代號</label>
            <el-input v-model="form.code" clearable></el-input>
          </div>
        </div>
        <div class="mm-col">
          <div class="mm-item">
            <label class="mm-label">銀行名稱</label>
            <el-input v-model="form.bankname" clearable></el-input>
          </div>
        </div>
      </div>
      <div class="mm-row">
        <div class="mm-col">
          <div class="mm-item">
            <label class="mm-label">銀行代碼</label>
            <el-input v-model="form.bankcode" clearable></el-input>
          </div>
        </div>
        <div class="mm-col">
          <div class="mm-item">
            <label class="mm-label">備註信息</label>
            <el-input v-model="form.mark" clearable></el-input>
          </div>
        </div>
      </div>
      <div class="mm-row">
        <div class="mm-col">
          <div class="mm-item">
            <label class="mm-label">創建時間</label>
            <div class="mm-row">
              <div class="mm-col">
                <el-date-picker type="date" placeholder="選擇日期" v-model="form.starttime" style="width: 100%;"></el-date-picker>
              </div>
              <div class="mmline">-</div>
              <div class="mm-col">
                <el-date-picker type="date" placeholder="選擇日期" v-model="form.endtime" style="width: 100%;"></el-date-picker>
              </div>
            </div>
          </div>
        </div>
        <div class="mm-col">
          <div class="mm-item">
            <label class="mm-label">狀態</label>
            <el-select v-model="form.status" placeholder="全部">
              <el-option label="全部" value="-1"></el-option>
              <el-option label="正常" value="0"></el-option>
              <el-option label="暫停" value="1"></el-option>
            </el-select>
          </div>
        </div>
      </div>
      <div class="mm-row">
        <div class="mm-col">
          <div class="mm-item">
            <label class="mm-label">賬戶餘額</label>
            <div class="mm-row">
              <div class="mm-col">
                <el-input type="number" v-model="form.startbalance" clearable></el-input>
              </div>
              <div class="mmline">-</div>
              <div class="mm-col">
                <el-input type="number" v-model="form.endbalance" clearable></el-input>
              </div>
            </div>
          </div>
        </div>
        <div class="mm-col">
          <div class="mm-item">
            <label class="mm-label">貨幣</label>
            <el-select v-model="form.currency_id" placeholder="全部">
              <el-option label="全部" value="-1"></el-option>
              <el-option v-for="(item,index) in currency" :key="index" :label="item.short_name+' '+item.name" :value="item.id"></el-option>
            </el-select>
          </div>
        </div>
      </div>
      <div class="mm-row">
        <div class="mm-col">
          <div class="mm-item">
            <label class="mm-label">排序字段</label>
            <el-select v-model="form.sortname" placeholder="全部">
              <el-option label="創建日期" value="addtime"></el-option>
              <el-option label="賬號代號" value="code"></el-option>
              <el-option label="賬號號碼" value="account_num"></el-option>
              <el-option label="賬號戶主" value="account_name"></el-option>
              <el-option label="銀行名稱" value="bankname"></el-option>
              <el-option label="狀態" value="status"></el-option>
              <el-option label="貨幣" value="currency_id"></el-option>
              <el-option label="餘額" value="balance"></el-option>
              <el-option label="備註" value="mark"></el-option>
              <el-option label="ID" value="id"></el-option>
            </el-select>
          </div>
        </div>
        <div class="mm-col">
          <div class="mm-item">
            <label class="mm-label">排序方式</label>
            <div class="mm-row">
              <div class="flex-start">
                <el-radio v-model="form.orderby" label="DESC">由高到低</el-radio>
                <el-radio v-model="form.orderby" label="ASC">由低到高</el-radio>
              </div>
            </div>
          </div>
        </div>

      </div>
      <div class="mm-submitbox">
        <div>
          <el-button type="primary" @click="submit" plain>清除</el-button>
          <el-button type="warning" @click="submit" plain>刷新</el-button>
        </div>
      </div>
    </el-form>
    <div @click="changesearchbox" class="rowline">
      <div>
        <i class="mm-nav-arrow el-icon-arrow-down" style="font-size: 12px; margin-right: 5px;"></i><span>{{search_hidden_text}}</span>
      </div>
    </div>

  </div>

</template>

<script>
export default {
  name: "Search",
  props: ['form'],
  data () {
    return {
      search_height: 0,
      search_hidden: true,
      search_hidden_text: '檢索展開',
      currency: [],
    }
  },
  methods: {
    submit () {
      this.form.account_num = "";
      this.form.account_name = "";
      this.form.code = "";
      this.form.bankcode = "";
      this.form.mark = "";
      this.form.bankname = "";
      this.form.starttime = "";
      this.form.endtime = "";
      this.form.startbalance = "";
      this.form.endbalance = "";
      this.form.currency_id = "-1";
      this.form.status = "-1";
      this.form.sortname = "addtime";
      this.form.orderby = "DESC";
      // this.$emit('submit', {});
    },
    getCurrency () {
      this.post('/api/bank/getcurrency', {

      }).then(response => {
        if (response.length > 0) {
          this.currency = response;
        } else {
          this.currency = [];
        }
      }).catch(error => {
        console.log(333);
      });
    },
    changesearchbox () {
      let search_height = this.$refs.form.$el.scrollHeight + 'px';
      if (this.search_hidden) {
        this.search_hidden = false;
        this.search_hidden_text = '檢索隱藏';
        this.search_height = search_height;
        console.log();

      } else {
        this.search_hidden = true;
        this.search_hidden_text = '檢索展開'
        this.search_height = 0;
      }
    }
  },
  created () {
    this.getCurrency();
  }

}
</script>

<style scoped>
.search {
  margin: 20px 0;
}
.searchform {
  transition: height ease 0.3s;
  overflow: hidden;
}

.rowline {
  border-bottom: 1px solid #66b1ff;
  display: flex;
  justify-content: center;
  padding-bottom: 5px;
  color: #409eff;
  cursor: pointer;
}
.search-hidden {
  height: 0;
  overflow: hidden;
}
@media screen and (max-width: 1024px) {
  .mm-submitbox {
    display: flex;
    justify-content: flex-end;
  }
  .mm-row {
    display: flex;
    flex-wrap: wrap;
    margin-bottom: 0;
  }
  .mm-col {
    flex: 1 100%;
    padding: 10px 0;
  }
  .mm-label {
    flex: 0 0 80px;
    padding-left: 0;
  }
}
</style>
